<template lang="pug">
//- client-only
Card#user-admin
  CardContent(class="sm:p-4 p-2")
    .grid.gap-y-4.grid-cols-auto.align-middle(class="md:grid-cols-2")
      UserPageRedirector
      div(class="md:mt-0 md:gap-x-6").nav-links.unselectable.text-right.flex.items-center.justify-end.gap-x-2
        Button.p-0(variant="link" @click="session?.switchAdminStatus") 切换界面
        Button.p-0(variant="link")
          NuxtLink(class="<md:ml-5px" :to="'/dashboard/' + user.id + '/tickets'")
            | {{ user.id }} 工单
        Button.p-0(variant="link")
          NuxtLink(class="<md:ml-5px" :to="'/dashboard/' + user.id + '/billing'")
            | {{ user.id }} 账单
        Button.p-0(variant="link")
          NuxtLink(class="<md:ml-5px" :to="'/dashboard/' + user.id + '/profile'")
            | Profile
        Button.p-0(variant="link" @click="userPref.showOrHideAdminPanel")
          NuxtLink(class="<md:ml-5px")
          | {{ show ? '收起' : '展开' }}
    keep-alive
      div.mt-4(v-if="show && user.id !== -1")
        div
          div.user-info.grid.gap-1.info(class="sm:grid-cols-2")
            div.left-part-info
              h5
                span.text-muted-foreground.font-normal 账号ID：
                NuxtLink(:to="'/dashboard/' + user.id" @click="$utils.copy(String(user.id))")
                  b {{ user.id }}
                span.text-muted-foreground.font-normal &nbsp;邮箱：
                NuxtLink(@click="$utils.copy(user.email)")
                  b {{ user.email }}
                  Icon(name="mdi:content-copy" class="inline-block ml-1 w-4 h-4")

                //- ObjectInspectDialog(:data="userInfoForInspect")
                Button.text-xs.p-0.m-0.ml-2.h-auto.text-primary(variant="link" :loading="inspectingUser" @click="inspectCurrentUser")
                  Icon(name="material-symbols-light:frame-inspect-rounded")
              h5(v-if="user.org_id")
                span.text-muted-foreground.font-normal 团队ID：
                NuxtLink(:to="`/orgdashboard/${user.org_id}`" class="inline-flex items-center gap-1")
                  b {{ user.org_id }}
                  Icon(name="lucide:external-link" class="w-3 h-3")
              h5(v-if="user.extra.was_referred_by") 
                span.text-muted-foreground.font-normal 推荐人：
                NuxtLink(:to="'/dashboard/' + user.extra.was_referred_by" )
                  b {{ user.extra.was_referred_by }}
              h5
                span.text-muted-foreground.font-normal 账户余额：
                b {{ $utils.currency(user.money, user.balance_currency) }} 
                //- |
                PLink.ml-1(:href="'https://dashboard.stripe.com/customers/' + user.extra.stripe_customer_id" target="_blank" type="success")
                  small
                    | Stripe账户
              h5
                span.text-muted-foreground.font-normal 动态PMW ID：
                b(:class="{ warning: user.extra.dynamic_pmw_user_id }") {{ user.extra.dynamic_pmw_user_id ? '是' : '否' }}
                //- PLink.ml-2(@click="useDynamicPMWUserId" :type="'primary'" :size="'small'") {{ user.extra.dynamic_pmw_user_id ? '关闭' : '开启' }}动态PMW ID
                //- Button.ml-2.p-0.px-2.text-xs.font-normal.h-6(size="sm" variant="outline" @click="useDynamicPMWUserId") {{ user.extra.dynamic_pmw_user_id ? '关闭' : '开启' }}动态PMW ID
                Switch.ml-2(:model-value="Boolean(user.extra.dynamic_pmw_user_id)" @update:modelValue="useDynamicPMWUserId")
              div.flex.flex-col(v-if="service.currentService")
                h5 
                  span.text-muted-foreground.font-normal 客户端信息：
                  //- LoadingOverlay.inline-block(:loading='lastOnlineClientLoading === "pending"')
                  b {{ lastOnlineClientStr }}
                  span.ml-2.text-xs.font-normal(
                    v-if="lastOnlineClientVerdict"
                    :class="lastOnlineClientVerdict.status === 'outdated' ? 'text-amber-600 dark:text-amber-400' : lastOnlineClientVerdict.status === 'error' ? 'text-destructive' : 'text-muted-foreground'") {{ lastOnlineClientVerdict.text }}
                h5
                  span.text-muted-foreground.font-normal {{ $t(service.currentService.cate) }} ID：
                  b {{ service.currentService?.id }}
                  b.ml-1.warning {{ service.currentService?.status === 'on' ? (service.currentService?.extra.shadow_ban ? '🤓已悄悄封禁' : '✅') : '⛔️' }} 
                  //- ObjectInspectDialog(:data="service.currentService")
                  Button.text-xs.p-0.m-0.ml-2.h-auto.text-primary(variant="link" @click="inspectObject(toRaw(service.currentService))")
                    Icon(name="material-symbols-light:frame-inspect-rounded")
                h5
                  span.text-muted-foreground.font-normal 标准流量：
                  b {{ $utils.trFormat(service.currentService?.used) }}
                  span.text-muted-foreground.font-normal  / 
                  span(v-if="service.currentService?.quote > 0") {{ $utils.trFormat(service.currentService?.quote) }}
                  span(v-else) 无限
                h5(v-if="service.currentService?.cate === 'allplatform'" :class="{ warning: service.currentService?.pre_used >= service.currentService?.pre_quota }")
                  span.text-muted-foreground.font-normal 中继流量：
                  b {{ $utils.trFormat(service.currentService?.pre_used) }}
                  span.text-muted-foreground.font-normal  / 
                  span {{ $utils.trFormat(service.currentService?.pre_quota) }}
                  span.text-muted-foreground.font-normal &nbsp;| 已购无限月数 all_pre:
                  span.ml-1 {{ service.currentService?.extra.all_pre || '-' }}
                  RelayDataAddonStateSheet(
                    :service="service.currentService"
                    @saved="doGetNotes"
                  )
                h5
                  span.text-muted-foreground.font-normal 后续月份协议配额：
                  b(v-if="service.currentService.extra.custom_monthly_quote != null") 标准 {{ service.currentService.extra.custom_monthly_quote }}GB
                  span.text-muted-foreground.font-normal(v-if="service.currentService.extra.custom_monthly_quote != null && service.currentService.extra.custom_monthly_pre_quota != null") &nbsp;/&nbsp;
                  b(v-if="service.currentService.extra.custom_monthly_pre_quota != null") 中继 {{ service.currentService.extra.custom_monthly_pre_quota }}GB
                  b(v-if="service.currentService.extra.custom_monthly_quote == null && service.currentService.extra.custom_monthly_pre_quota == null") 未设置
                  ChangeMonthlyQuote
                h5
                  span.text-muted-foreground.font-normal 服务到期：
                  b {{ duetime || '—' }}
                  AnchorBillingSheet(:service="service.currentService")
                  span.text-muted-foreground.font-normal &nbsp;| buy_length:
                  b.ml-1 {{ service.currentService?.extra.buy_length }}
                StoreReleaseSheet(:service="service.currentService")
                h5
                  span.text-muted-foreground.font-normal 当前升级计费比例：
                  b {{ upgradeBillingRatio }}
                .flex.flex-wrap.items-center.gap-x-2
                  BillingModeExplainer(:service="service.currentService")
                  ServicePeriodsSheet(:user-id="user.id" :service-id="service.currentService.id")
                h5
                  span.text-muted-foreground.font-normal 设备上限：
                  b {{ service.currentService?.extra.device_limit || '未设定，为默认值' }}
                h5(v-if="service.currentService?.extra.device_limit")
                  span.text-muted-foreground.font-normal 上限有效期：
                  b {{ sharingDueDate }} 
                  span.text-muted-foreground.font-normal (device_limit_valid: 
                  b.ml-1 {{ service.currentService?.extra.device_limit_valid }}
                  span.text-muted-foreground.font-normal )
              .grid.grid-flow-col.gap-1.justify-items-start
                Button.text-xs.h-6(size="sm" variant="destructive" @click="delService") 删除服务
                Button.text-xs.h-6(size="sm" variant="warning" :loading="stoppingCurrentMonth" @click="stopServiceCurrentMonth") 停止本期服务
                Button.text-xs.h-6(size="sm" variant="destructive" :disabled="resettingConfig" @click="resetServiceConfigInfo") 重置配置
                // Split action: main button + dropdown
                .inline-flex.items-center
                  Button.text-xs.h-6.pr-2.rounded-r-none.border-r-0(:variant="service.currentService?.extra.shadow_ban ? 'success' : 'warning'" size="sm" @click="shadowBanService") 悄悄{{ service.currentService?.extra.shadow_ban ? '恢复' : '封禁' }}服务
                  DropdownMenu
                    DropdownMenuTrigger(as-child)
                      Button.h-6.px-1.-ml-px.rounded-l-none(:variant="service.currentService?.extra.shadow_ban ? 'success' : 'warning'" size="sm")
                        Icon(name="material-symbols:arrow-drop-down" class="h-4 w-4")
                    DropdownMenuContent
                      DropdownMenuItem(v-for="protocol in protocolKeys" :key="protocol" @click="switchProtocol(protocol)")
                        | {{ service.currentService?.extra[`${protocol}_disabled`] ? '启用' : '禁用' }}{{ protolNameMap[protocol] }}
              //- Client-only fetching is idle during SSR and pending before hydration.
              AbuseNotes.my-2.mt-4(:userId='user.id' v-model:notes="notes" :loading="notesLoading === 'idle' || notesLoading === 'pending'" :error="notesError" relatedMatter="general" :serviceId="route.name !== 'pricing' ? service.currentService?.id : undefined"  ref="notesRef" v-if="user?.id")

            div.right-part-info.flex.flex-col.gap-0
              h5 
                span.text-muted-foreground.font-normal 账户状态
                b.ml-1.mr-2 {{ user.extra && user.extra.suspend ? '❌' : '✅' }}
                //- Button.p-0.px-2.text-xs.font-normal.h-6(size="sm" :variant="user.extra.suspend ? 'success' : 'warning'" @click="suspendAccount('suspend')") {{ user.extra.suspend ? '恢复' : '停用' }}账号
                Switch(:model-value="revAccountSuspended" @update:modelValue="suspendAccount('suspend')" :disabled="updating")
              h5 
                span.text-muted-foreground.font-normal 客服权限
                b.ml-1.mr-2 {{ user.extra && user.extra.tk_suspend ? '❌' : '✅' }}
                //- Button.p-0.px-2.text-xs.font-normal.h-6(size="sm" :variant="user.extra.tk_suspend ? 'success' : 'warning'" @click="suspendAccount('tk_suspend')") {{ user.extra.tk_suspend ? '恢复' : '暂停' }}客服
                Switch(:model-value="revSupportSuspended" @update:modelValue="suspendAccount('tk_suspend')" :disabled="updating")
              h5 
                span.text-muted-foreground.font-normal 购买权限
                b.ml-1.mr-2 {{ user.extra && user.extra.buy_suspend ? '❌' : '✅' }}
                //- Button.p-0.px-2.text-xs.font-normal.h-6(size="sm" :variant="user.extra.buy_suspend ? 'success' : 'warning'" @click="suspendAccount('buy_suspend')") {{ user.extra.buy_suspend ? '恢复' : '暂停' }}购买
                Switch(:model-value="revBuySuspended" @update:modelValue="suspendAccount('buy_suspend')" :disabled="updating")
                //- span.ml-2.leading-3
                div.ml-2.inline-flex.gap-x-2
                  .flex.items-center
                    Checkbox.h-4.w-4.shrink-0(v-model="blockPaymentAsWell" :id="compId + '-blockPaymentAsWell'")
                    label.clickable(:for="compId + '-blockPaymentAsWell'") {{ user.extra.buy_suspend ? '解' : '' }}封关联支付账户
                  .flex.items-center
                    Checkbox.h-4.w-4.shrink-0(v-model="blockDevicesAsWell" :id="compId + '-blockDevicesAsWell'")
                    label.clickable(:for="compId + '-blockDevicesAsWell'") {{ user.extra.buy_suspend ? '解' : '' }}封设备
              h5 
                span.text-muted-foreground.font-normal 东南亚用
                b.ml-1.mr-2 {{ user.extra && user.extra.allow_sea ? '✅' : '❌' }}
                //- Button.p-0.px-2.text-xs.font-normal.h-6(variant="default" :size="'sm'" @click="toggleAllowSea") {{ user.extra.allow_sea ? '禁止' : '允许' }}
                Switch(:model-value="Boolean(user.extra.allow_sea)" @update:modelValue="toggleAllowSea")
              h5
                span.text-muted-foreground.font-normal 允许关闭GFW MRS（回家服务）
                b.ml-1.mr-2 {{ allowDisableGfwMrs ? '✅' : '❌' }}
                Switch(:model-value="allowDisableGfwMrs" :disabled="updatingGfwMrsPermission" @update:modelValue="setAllowDisableGfwMrs")
              h5(v-if="user.extra?.suspend_reason || user.extra?.suspend_review_reason") 
                span.text-muted-foreground.font-normal 封禁审核：
                b {{ user.extra.suspend_reason || '-' }}
                b(v-if="user.extra.suspend_review_reason") 待审核因素：{{ user.extra.suspend_review_reason }}
              h5(v-if="user.riskRecord") 
                span.text-muted-foreground.font-normal 风险信息：
                b {{ user.riskRecord ? user.riskRecord.reason : '无' }}
              //- LoadingOverlay.w-full.inline-block(:loading="allowedPaymentMethodsLoading === 'pending'")
              //- div.w-full.text-left
              h5
                span.text-muted-foreground.font-normal PayPal
                b.ml-1.mr-2 {{ paypalAllowed ? '✅' : '❌' }}
                Switch(:model-value="paypalAllowed" @update:modelValue="paypalAllowed ? disallowPaymentMethods('paypal') : allowPaymentMethods('paypal')" v-if="!allowedPaymentMethodsFromServer?.includes('paypal')")
              h5
                span.text-muted-foreground.font-normal Clash 默认配置编辑
                b.ml-1.mr-2 {{ allowClashDefaults ? '✅' : '❌' }}
                Switch(:model-value="allowClashDefaults" @update:modelValue="toggleAllowEditClashDefaults")
              h5
                span.text-muted-foreground.font-normal 客户端HY2带宽设定
                b.ml-1.mr-2 {{ allowHy2Bandwidth ? '✅' : '❌' }}
                Switch(:model-value="allowHy2Bandwidth" @update:modelValue="toggleAllowSetHy2Bandwidth")
              h5
                span.text-muted-foreground.font-normal 客户端核心选择
                b.ml-1.mr-2 {{ allowCoreEngineSelection ? '✅' : '❌' }}
                Switch(:model-value="allowCoreEngineSelection" @update:modelValue="toggleAllowCoreEngineSelection")
              h5
                span.text-muted-foreground.font-normal 客户端外部核心管理
                b.ml-1.mr-2 {{ allowManageExternalBinaries ? '✅' : '❌' }}
                Switch(:model-value="allowManageExternalBinaries" @update:modelValue="toggleAllowManageExternalBinaries")
              h5
                span.text-muted-foreground.font-normal 允许回家服务增强模式
                b.ml-1.mr-2 {{ allowHomeTunMode ? '✅' : '❌' }}
                Switch(:model-value="allowHomeTunMode" @update:modelValue="toggleAllowHomeTunMode")
              h5
                span.text-muted-foreground.font-normal 客户端 Naive 配置选项
                b.ml-1.mr-2 {{ allowNaiveConfigOptions ? '✅' : '❌' }}
                Switch(:model-value="allowNaiveConfigOptions" @update:modelValue="toggleAllowNaiveConfigOptions")
              h5
                span.text-muted-foreground.font-normal 客户端网速测试
                b.ml-1.mr-2 {{ allowSpeedTest ? '✅' : '❌' }}
                Switch(:model-value="allowSpeedTest" @update:modelValue="toggleAllowSpeedTest")
              h5 
                span.text-muted-foreground.font-normal 域名：
                PLink(@click="$utils.copy(user.site_domain)" type="primary") 
                  | {{ user.site_domain }}
                  Icon(name="mdi:content-copy" class="inline-block ml-1 w-4 h-4")
              h5 
                span.text-muted-foreground.font-normal 密码修改于：
                span.mr-1(v-if="user.extra.pwd_update") {{ $utils.relativeTime(user.extra.pwd_update * 1000) }} |
                b {{ user.extra.pwd_update ? $utils.dateStr(user.extra.pwd_update * 1000) : `${$utils.dateStr(user.created_at)} 注册后没改过` }}
                span.ml-2.inline-flex
                  ServiceResetRecordsSheet(:user-id="user.id" :refresh-key="resetRecordsVersion")
              client-only
                LoadingOverlay.w-full.text-xs.inline-block.text-left(:loading='intercomLoading === "pending"')
                  template(v-if="intercomInfo")
                    TooltipProvider.inline-block
                      Tooltip
                        TooltipTrigger(as="h5")
                          h5
                            PLink(type="success" :href="intercomInfo.link" target="_blank")
                              | Intercom
                              Icon(name="octicon:link-external-16" class="font-size-10px mr-1")
                            b {{ intercomInfo.lastOnline }}
                            b.mx-1 {{ intercomInfo.location }}
                            IPWithGeo(:ip="intercomInfo.ip") 
                        TooltipContent.max-w-xs
                          | {{ intercomInfo.lastOnlineRel }}
                  h5(v-else-if="intercomProfile") 未找到Intercom信息，可能从未在网站/客户端加载过Intercom
              div.usage-data.gap-y-2(v-if="currentService")
                div
                  LazyMonthlyUsage(:serviceId='currentService?.id')
                div
                  LazyIPLog(@take-snapshot="addNote")
        div.bottom-part-info
          div.text-center
            Button(variant="link" @click="userPref.showOrHideEditors") {{ showEditors ? '隐藏' : '显示' }}更多功能
          div
            div.operations(v-show="showEditors")
              div.edit.grid.gap-2(class="sm:grid-cols-2 lg:grid-cols-2")
                div
                  AddMoney
                template(v-if="currentService")
                  div
                    LazyChangeBuylength
                  div
                    LazyChangeDataQuota
                  div
                    LazyChangeDeviceLimit
</template>

<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { h, toRaw } from 'vue'
import { Input } from '@/components/ui/input'
import { useUser } from '~/stores/useUser'
import { resolveUpgradeProrationRatio, usePricing } from '~/stores/usePricing'
import { useUserService } from '~/stores/useUserService'
import { useVisitorSession } from '~/stores/useVisitorSession'
import { toast } from '~/utils/sonner'
import { appleIdsPartial } from '~/utils/appleAccount'
import LoadingOverlay from '@/components/ui/loading-overlay'
const compId = useId()
// const prop = defineProps<{
//   serviceControl: boolean
// }>()
const notesRef = ref()
const user = useUser()
const pricing = usePricing()
const service = useUserService()
const session = useVisitorSession()
const dayjs = useDayjs()
const route = useRoute()
const $utils = useUtils()
const { inspectObject, trFormat } = $utils

const $t = useI18n().t

const blockPaymentAsWell = ref(false)
const blockDevicesAsWell = ref(false)
const updating = ref(false)
const inspectingUser = ref(false)
const stoppingCurrentMonth = ref(false)
const resettingConfig = ref(false)
const resetRecordsVersion = ref(0)
const userPref = useUserPref()
const show = computed(() => userPref.showAdminPanel)

const currentService = computed(() => service.currentService)
const { period: expiredPeriod, pending: expiredPeriodPending, error: expiredPeriodError } = useExpiredAnchorPeriod(() => service.currentService)

const protocolKeys = ref(['ssltide', 'v2', 'trojan', 'hy2'])

const protolNameMap = {
  ssltide: 'SSLTide',
  v2: 'V2Ray',
  trojan: 'Trojan',
  hy2: 'Hysteria 2',
}

const revAccountSuspended = computed(() => {
  return !user.extra.suspend
})

const revSupportSuspended = computed(() => {
  return !user.extra.tk_suspend
})

const revBuySuspended = computed(() => {
  return !user.extra.buy_suspend
})

// const routeName = computed(() => useRoute().name)

// const lastOnlineClientInfo = ref({} as ClientHeartBeat)
// const allowedPaymentMethodsFromServer = ref([] as string[])
// const notes = ref([] as Note[])
// const intercomProfile = ref({} as {
//   id: string
//   last_seen_ip: string
//   last_seen_at: number
//   workspace_id: string
//   location: {
//     city: string
//     country: string
//     region: string
//   },
//   custom_attributes: {
//     last_seen_ip: string
//   }
// })
const showEditors = computed(() => userPref.showEditors)
const currentUserId = computed(() => user.id)
const currentServiceUserId = computed(() => currentService.value?.user_id)
const allowedPaymentMethodsFromServer = computed(() => user.allowedPaymentMethodsFromServer)

watch(
  currentUserId,
  (userId) => {
    if (userId !== -1) {
      void getAllowedPaymentMethodsFromServer(userId)
    }
  },
)

const lastOnlineClientStr = computed(() => {
  // console.log('calculating lastOnlineClientStr:', lastOnlineClientInfo.value)
  const cl = lastOnlineClientInfo.value
  // console.log('cl is:', cl)
  if (!cl?.version) {
    return '未找到 :('
  }
  return `${cl?.version} ${cl?.platform}-${cl?.arch}-${cl?.release}`
})
const { loadFor: loadLatestVersions, verdictFor: latestVersionVerdictFor } = useClientLatestVersion()
const lastOnlineClientVerdict = computed(() =>
  lastOnlineClientInfo.value?.version ? latestVersionVerdictFor(lastOnlineClientInfo.value) : null,
)
const duetimeOri = computed(() => {
  if (expiredPeriodPending.value || expiredPeriodError.value) return null
  if (expiredPeriod.value) return dayjs(expiredPeriod.value.period_end).tz('Asia/Shanghai')
  if (!service.currentService?.extra.buy_length) {
    return null
  }
  if (isAnchorBilledService(service.currentService)) {
    return anchoredServiceExpiry(dayjs, service.currentService)
  }
  const buyTime = dayjs(service.currentService?.extra?.buy_time).tz('Asia/Shanghai')
  const duetime = buyTime.set('date', 1).add(Number(service.currentService?.extra?.buy_length), 'month').set('date', 1)
  return duetime
})

const duetime = computed(() => {
  if (service.currentService?.plan_id === -1) {
    return '无限期'
  }
  // console.log('------>>> admin duetime', duetimeOri.value)
  const anchored = expiredPeriod.value || isAnchorBilledService(service.currentService)
  return duetimeOri.value?.format(anchored ? 'YYYY年M月DD日 HH:mm:ss' : 'YYYY年M月DD日')
})

function serviceBillingRatio(dayjsFactory: any, currentService: any, now: any, anchorBillingScope: string) {
  const totalDays = now.daysInMonth()
  const today = now.date()
  const naturalMonthRatio = (totalDays - today + 1) / totalDays
  const ratio = resolveUpgradeProrationRatio(
    dayjsFactory,
    currentService,
    naturalMonthRatio,
    anchorBillingScope,
  )
  return `${Math.round(ratio * 100)}%`
}
const upgradeBillingRatio = computed(() => serviceBillingRatio(
  dayjs,
  service.currentService,
  dayjs().tz('Asia/Shanghai'),
  pricing.anchorBillingScope,
))

const sharingDueDate = computed(() => {
  if (!service.currentService?.extra.device_limit_valid) {
    return 0
  }
  return dayjs().tz('Asia/Shanghai').add(Number(service.currentService?.extra.device_limit_valid), 'month').format('YYYY年MM月1日')
})

const paypalAllowed = computed(() => {
  return user?.extra?.allowed_payment_methods?.includes('paypal') || allowedPaymentMethodsFromServer.value?.includes('paypal')
})

const allowClashDefaults = computed(() => Boolean(user.extra?.allowEditClashDefaults))
const allowHy2Bandwidth = computed(() => Boolean(user.extra?.allowSetHy2Bandwidth))
const allowCoreEngineSelection = computed(() => Boolean(user.extra?.allowCoreEngineSelection))
const allowManageExternalBinaries = computed(() => Boolean(user.extra?.allowManageExternalBinaries))
const allowHomeTunMode = computed(() => Boolean(user.extra?.allowHomeTunMode))
const allowDisableGfwMrs = computed(() => user.extra?.allowDisableGfwMrs === true)
const updatingGfwMrsPermission = ref(false)
const allowNaiveConfigOptions = computed(() => Boolean(user.extra?.allowNaiveConfigOptions))
const allowSpeedTest = computed(() => Boolean(user.extra?.allowSpeedTest))

const intercomInfo = computed(() => {
  return {
    lastOnline: intercomProfile.value?.last_seen_at ? $utils.dateStr(intercomProfile.value?.last_seen_at * 1000) : '-',
    lastOnlineRel: intercomProfile.value?.last_seen_at ? $utils.relativeTime(intercomProfile.value?.last_seen_at * 1000) : '-',
    // @ts-ignore
    link: `https://app.intercom.io/a/apps/${intercomProfile.value?.workspace_id}/users/${intercomProfile.value?.id}/all-conversations`,
    location: `${intercomProfile.value?.location?.region} - ${intercomProfile.value?.location?.city}, ${intercomProfile.value?.location?.country}`,
    // @ts-ignore
    ip: intercomProfile.value?.last_seen_ip || intercomProfile.value?.custom_attributes?.last_seen_ip,
  }
})

const {
  data: notes,
  status: notesLoading,
  error: notesError,
  execute: doGetNotes,
} = useAsyncData(
  `abusenotes-${user.id}`,
  () => getNotes({ userId: currentServiceUserId.value }),
  {
    watch: [currentServiceUserId],
    immediate: true,
    server: false,
    default: () => null,
  },
)
const {
  data: lastOnlineClientInfo,
  status: lastOnlineClientLoading,
  execute: doGetLastOnlineClient,
} = useAsyncData(
  `lastOnlineClient-${user.id}`,
  () => getLastOnlineClient(),
  {
    watch: [currentUserId],
    immediate: true,
    server: false,
    default: () => ({} as ClientHeartBeat),
  },
)
watch(lastOnlineClientInfo, (info) => {
  if (info?.version) loadLatestVersions([info])
}, { immediate: true })
const {
  data: intercomProfile,
  status: intercomLoading,
  execute: doGetIntercomProfile,
} = useAsyncData(`intercomProfile-${user.id}`, user.getIntercomProfile, { watch: [currentUserId], immediate: false })

onMounted(() => {
  // doGetNotes()
  // doGetAllowedPaymentMethods()
  // doGetLastOnlineClient()
  if (currentUserId.value !== -1) {
    void getAllowedPaymentMethodsFromServer(currentUserId.value)
  }
  doGetIntercomProfile()
})

async function inspectCurrentUser() {
  inspectingUser.value = true
  try {
    const freshUser = await user.getUserInfo({ id: user.id, reload: true })
    if (!freshUser) {
      throw new Error('User API returned no data')
    }
    user.setUserData(freshUser)
    inspectObject(toRaw(freshUser))
  } catch (error: any) {
    toast({
      title: '获取完整用户数据失败',
      description: error?.data?.message || error?.message || String(error),
      variant: 'destructive',
    })
  } finally {
    inspectingUser.value = false
  }
}

async function suspendAccount(flipOption: string) {
  const opt: any = {
    user_id: user.id,
  }
  opt[flipOption] = true
  // When turning ON suspend or buy_suspend, give the admin a chance to record
  // a free-text reason. Empty/cancel falls back to a synthetic reason on the
  // backend identifying the admin and timestamp.
  const turningOn =
    (flipOption === 'suspend' && !user.extra.suspend) ||
    (flipOption === 'buy_suspend' && !user.extra.buy_suspend)
  if (turningOn) {
    const title = flipOption === 'suspend' ? '停用账号' : '暂停购买'
    let reason = ''
    const confirmed = await useDialog().confirm({
      title,
      body: h('div', { class: 'flex flex-col gap-2' }, [
        h('p', { class: 'text-sm text-muted-foreground' }, '原因（可选，留空将自动记录操作人）：'),
        h(Input, {
          autofocus: true,
          placeholder: '原因（可选）',
          'onUpdate:modelValue': (v: string | number) => {
            reason = String(v)
          },
        }),
      ]),
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonVariant: 'warning',
    })
    if (confirmed === 'confirm' && reason.trim()) {
      opt.reason = reason.trim()
    }
  }
  const wasBuySuspended = Boolean(user.extra.buy_suspend)
  let accountUpdated = false
  updating.value = true
  try {
    const data = await useAdmin.suspendAccount(opt)
    console.log('suspend result:', data)
    if (!data) {
      throw new Error('Suspend account returned no result')
    }
    user.updateExtra(data.result)
    accountUpdated = true

    const relatedOperations: Promise<unknown>[] = []
    if (flipOption === 'buy_suspend' && blockPaymentAsWell.value) {
      relatedOperations.push(
        wasBuySuspended ? unblockPayment(false) : blockPayment(false),
      )
    }
    if (flipOption === 'buy_suspend' && blockDevicesAsWell.value) {
      relatedOperations.push(
        wasBuySuspended ? unblockDevice(false) : blockDevice(false),
      )
    }
    const relatedResults = await Promise.allSettled(relatedOperations)
    const failures = relatedResults.filter(result => result.status === 'rejected')
    if (failures.length) {
      throw new Error(failures.map(result => String(result.reason)).join('; '))
    }

    toast({
      title: `${$t(flipOption)} 已设置为 ${data.result[flipOption]}`,
    })
  } catch (error: any) {
    toast({
      title: accountUpdated ? '购买权限已更新，但关联封禁操作失败' : '账户状态更新失败',
      description: error?.data?.message || error?.message || String(error),
      variant: 'destructive',
    })
  } finally {
    updating.value = false
  }
}
async function toggleAllowSea() {
  const opt = {
    user_id: user.id,
    allow_sea: !user.extra.allow_sea,
  }
  const data = await useAdmin.allowSea(opt)
  user.updateExtra({ ...data })
  toast({
    title: `allow_sea 已设置为 ${data?.allow_sea}`,
  })
}
async function setAllowDisableGfwMrs(allow: boolean) {
  if (updatingGfwMrsPermission.value) return
  updatingGfwMrsPermission.value = true
  try {
    const result = await useAdmin.setClientFeatureFlag({ user_id: user.id, flag: 'allowDisableGfwMrs', allow })
    if (result?.flag !== 'allowDisableGfwMrs' || typeof result.value !== 'boolean') throw new Error('后台未确认权限已保存')
    user.updateExtra({ allowDisableGfwMrs: result.value })
    toast({ title: `关闭 GFW MRS 权限已${result.value ? '允许' : '禁止'}` })
  } catch (error: any) {
    toast({ title: '更新失败', description: error?.message || String(error), variant: 'destructive' })
  } finally {
    updatingGfwMrsPermission.value = false
  }
}
async function toggleAllowEditClashDefaults() {
  const desired = !allowClashDefaults.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowEditClashDefaults',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowEditClashDefaults: nextValue })
    toast({
      title: 'Clash 默认配置编辑权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowSetHy2Bandwidth() {
  const desired = !allowHy2Bandwidth.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowSetHy2Bandwidth',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowSetHy2Bandwidth: nextValue })
    toast({
      title: 'HY2 带宽提示权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowCoreEngineSelection() {
  const desired = !allowCoreEngineSelection.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowCoreEngineSelection',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowCoreEngineSelection: nextValue })
    toast({
      title: '客户端核心选择权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowManageExternalBinaries() {
  const desired = !allowManageExternalBinaries.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowManageExternalBinaries',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowManageExternalBinaries: nextValue })
    toast({
      title: '外部核心管理权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowHomeTunMode() {
  const desired = !allowHomeTunMode.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowHomeTunMode',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowHomeTunMode: nextValue })
    toast({
      title: 'Home 线路增强模式权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowNaiveConfigOptions() {
  const desired = !allowNaiveConfigOptions.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowNaiveConfigOptions',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowNaiveConfigOptions: nextValue })
    toast({
      title: 'Naive 配置选项权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function toggleAllowSpeedTest() {
  const desired = !allowSpeedTest.value
  try {
    const result = await useAdmin.setClientFeatureFlag({
      user_id: user.id,
      flag: 'allowSpeedTest',
      allow: desired,
    })
    const nextValue = typeof result?.value === 'boolean' ? result.value : desired
    user.updateExtra({ allowSpeedTest: nextValue })
    toast({
      title: '网速测试权限已更新',
      description: `现在为 ${nextValue ? '允许' : '禁止'}，客户刷新账号后生效`,
    })
  } catch (error: any) {
    toast({
      title: '更新失败',
      description: error?.message || String(error),
      variant: 'destructive',
    })
  }
}
async function resetServiceConfigInfo() {
  if (resettingConfig.value || !service.currentService) return
  const serviceId = service.currentService.id as number
  const confirmed = await useDialog().confirm({
    title: '重置配置',
    body: `确认要重置用户 ${user.id} 的服务 ${serviceId} 配置吗？`,
    confirmButtonText: '重置',
    cancelButtonText: '取消',
    confirmButtonVariant: 'warning',
  })
  if (confirmed !== 'confirm') {
    return
  }
  resettingConfig.value = true
  try {
    await service.resetServiceConfigInfo({ serviceId })
    resetRecordsVersion.value++
    toast({
      title: '服务信息已重置',
      description: '已记录本次重置，节点同步可能稍后完成。',
    })
    try {
      await service.getCurrentUserService({ refresh: true })
    } catch {
      toast({ title: '配置已重置，页面数据刷新失败', description: '请刷新页面后查看新配置。', variant: 'destructive' })
    }
  } catch (e) {
    toast({
      title: '重置失败',
      description: '请稍后重试或查看重置记录确认结果。',
      variant: 'destructive',
    })
  } finally {
    resettingConfig.value = false
  }
}
async function useDynamicPMWUserId() {
  const opt = {
    userId: user.id,
  }
  try {
    const ret: any = await useAdmin.useDynamicPMWUserId(opt)
    if (ret.result.success) {
      toast({
        title: '设置成功',
        description: `已设置为 ${ret.result.dynamic_pmw_user_id}`,
      })
      user.updateExtra({ dynamic_pmw_user_id: ret.result.dynamic_pmw_user_id })
    } else {
      toast({
        title: '设置失败',
        description: ret.result.reason,
        variant: 'destructive',
      })
    }
  } catch (e) {
    toast({
      title: '设置失败',
      description: JSON.stringify(e),
      variant: 'destructive',
    })
  }
}
async function delService() {
  const confirmed = await useDialog().confirm({
    title: '删除/停用服务',
    body: `确认要删除/停用用户 ${user.id} 的服务 ${service.currentService?.id} 吗？`,
    confirmButtonText: '删除/停用',
    cancelButtonText: '取消',
    confirmButtonVariant: 'destructive',
  })

  if (confirmed !== 'confirm') {
    return
  }

  try {
    await useAdmin.delService({ service_id: service.currentService?.id })
    service.currentService!.status = 'off'
    service.currentService!.extra.buy_length = 1
    toast({
      title: '服务已删除',
      description: '',
    })
  } catch (e) {
    toast({
      title: '删除失败',
      description: JSON.stringify(e),
      variant: 'destructive',
    })
  }
}
async function stopServiceCurrentMonth() {
  if (!service.currentService?.id) {
    toast({
      title: '停止失败',
      description: '当前没有可操作的服务',
      variant: 'destructive',
    })
    return
  }
  if (service.currentService.extra.buy_length < 2) {
    toast({
      title: '操作不对哦',
      description: '当前服务只剩本月的了，请直接删除服务',
      variant: 'destructive',
    })
    return
  }
  const confirmed = await useDialog().confirm({
    title: '停止本期服务',
    body: `确认要停止用户 ${user.id} 的服务 ${service.currentService.id} 吗？\n\n这个操作只会停用本期服务并触发账号删除，不会减少 buy_length；如果还有后续月份，下一周期 auto_rebuy 会自动恢复服务。`,
    confirmButtonText: '停止本期',
    cancelButtonText: '取消',
    confirmButtonVariant: 'warning',
  })

  if (confirmed !== 'confirm') {
    return
  }

  stoppingCurrentMonth.value = true
  try {
    const ret: any = await useAdmin.stopServiceCurrentMonth({ service_id: service.currentService.id })
    const result = ret?.result
    service.currentService.status = result?.status || 'off'
    if (result?.extra) {
      service.currentService.extra = {
        ...service.currentService.extra,
        ...result.extra,
      }
    }
    toast({
      title: '本期服务已停止',
      description: 'buy_length 已保留，后续月份会由 auto_rebuy 恢复。',
    })
  } catch (e) {
    toast({
      title: '停止本月服务失败',
      description: JSON.stringify(e),
      variant: 'destructive',
    })
  } finally {
    stoppingCurrentMonth.value = false
  }
}
async function blockPayment(showResult = true) {
  const ret = await useAdmin.blockUserPayPalPayer({ userId: user.id })
  const partial = appleIdsPartial(ret)
  if (partial) {
    toast({ title: '部分 Apple 账户未能读取，已封禁已知账户', description: partial.reason ?? undefined, variant: 'warning' })
  }
  if (showResult) {
    useDialog().alert({
      title: '封关联支付账户结果',
      body: JSON.stringify(ret, null, 2),
      confirmButtonText: $t('ok'),
    })
  }
  return ret
}
async function unblockPayment(showResult = true) {
  const ret = await useAdmin.unblockUserPayPalPayer({ userId: user.id })
  if (showResult) {
    useDialog().alert({
      title: '解封关联支付账户结果',
      body: JSON.stringify(ret, null, 2),
      confirmButtonText: $t('ok'),
    })
  }
  return ret
}
async function getLastOnlineClient() {
  if (!user.id) {
    return {}
  }
  try {
    const data = await useAdmin.getUserClientHeartbeat({ userId: user.id!, opt: {} })
    // lastOnlineClientInfo.value = data?.[0] || {}
    // console.log('getLastOnlineClient data:', '--- will return ', data?.[0] || {})
    return data?.[0] || {}
  } catch (error: any) {
    console.error('getLastOnlineClient failed:', error)
    return {}
  }
}
async function blockDevice(showResult = true) {
  const ret: any = await useAdmin.blockUserDevice({ userId: user.id })
  const failures = ret.filter(result => result.status === 'rejected')
  if (failures.length) {
    throw new Error(failures.map(result => String(result.reason)).join('; '))
  }
  if (showResult) {
    useDialog().alert({
      title: 'Device Block Result',
      body:
        `Blocked: ${ret.length} \n\n` +
        JSON.stringify(
          ret.map((r) => r.value),
          null,
          2,
        ),
      confirmButtonText: $t('ok'),
    })
  }
  return ret
}
async function unblockDevice(showResult = true) {
  const ret = await useAdmin.unblockUserDevice({ userId: user.id })
  if (showResult) {
    useDialog().alert({
      title: 'Device Unblock Result',
      body: `Unblocked: ` + JSON.stringify(ret, null, 2),
      confirmButtonText: $t('ok'),
    })
  }
  return ret
}
async function allowPaymentMethods(methodName) {
  const userId = user.id!
  const allowedPaymentMethods = [...(user?.extra?.allowed_payment_methods || []), methodName]
  const data = await useAdmin.setAllowedPaymentMethod({
    userId,
    allowedPaymentMethods,
  })
  await user.refreshAllowedPaymentMethods(userId).catch(error => console.error('Refreshing allowed payment methods failed:', error))
  useDialog().alert({
    title: 'Payment Method Allowed',
    body: JSON.stringify(data, null, 2),
    confirmButtonText: $t('ok'),
  })
}
async function disallowPaymentMethods(methodName) {
  if (allowedPaymentMethodsFromServer.value?.includes('paypal')) {
    return useDialog().alert({
      title: 'Failed',
      body: '系统规则已默认允许，无法禁用。',
      confirmButtonText: $t('ok'),
    })
  }
  const userId = user.id!
  const allowedPaymentMethods = (user?.extra?.allowed_payment_methods || []).filter((m) => m !== methodName)
  const data = await useAdmin.setAllowedPaymentMethod({
    userId,
    allowedPaymentMethods,
  })
  await user.refreshAllowedPaymentMethods(userId).catch(error => console.error('Refreshing allowed payment methods failed:', error))
  useDialog().alert({
    title: 'Payment Method Disallowed',
    body: JSON.stringify(data, null, 2),
    confirmButtonText: $t('ok'),
  })
}
async function getAllowedPaymentMethodsFromServer(userId: number | string = user.id) {
  try {
    await user.getAllowedPaymentMethods(userId)
  } catch (e) {
    console.log(e)
  }
}
async function getNotes(query) {
  if (!query?.userId) {
    return null
  }
  const ctx = {
    // greaterThanOrEqualTo: {
    //   createdAt: dayjs().startOf('month').toDate(),
    // },
    // equalTo: {
    //   relatedMatter: 'general',
    // },
    // containedIn: {
    //   serviceId: serviceIdArray,
    // },
    equalTo: {
      ...query,
    },
  }
  return (await useAdmin.getTrAbuseNotes(ctx)) || []
}
// function addNote(newNote) {
//   notes.value.push(newNote)
// }
// function delNote(note) {
//   notes.value = notes.value.filter(n => n.objectId !== note.objectId)
// }
async function shadowBanService() {
  try {
    const ret = await useAdmin.shadowBanService({ serviceId: service.currentService?.id })
    service.updateExtra(ret)
    toast({
      title: 'Shadow Ban',
      description: JSON.stringify(ret, null, 2),
    })
  } catch (e) {
    toast({
      title: 'Shadow Ban',
      description: JSON.stringify(e, null, 2),
      variant: 'destructive',
    })
  }
}

async function switchProtocol(protocol) {
  if (!service.currentService?.id) {
    return toast({
      title: 'Ban Protocol',
      description: 'No service selected',
    })
  }
  try {
    const ret = await useAdmin.switchProtocol({ serviceId: service.currentService?.id, protocol })
    // @ts-ignore
    service.updateExtra(ret)
    toast({
      title: 'Ban Protocol',
      description: JSON.stringify(ret, null, 2),
    })
  } catch (e) {
    toast({
      title: 'Ban Protocol',
      description: JSON.stringify(e, null, 2),
      variant: 'destructive',
    })
  }
}

function addNote(content) {
  notesRef.value.doAddNote(content)
}
</script>

<style lang="postcss" scoped>

.info {
  h3 {
    font-weight: 500;
    color: var(--secondary-color);
    font-size: 1rem;

    &.warning {
      color: var(--carrot);

      * {
        color: var(--carrot);
      }
    }

    b {
      color: var(--primary-color);
      margin-right: 10px;
    }

    a {
      color: var(--primary-color);

      /* font-size: 10px; */
      i {
        margin-left: 5px;
      }

      /* &:hover {
          text-decoration: underline;
        } */
    }
  }
}

.tr {
  font-weight: 400;
  font-size: 12px;

  b {
    font-weight: 500;
    font-size: 16px;
  }

  .date {
    b {
      font-size: 12px;
    }
  }
}

b.warning {
  color: var(--carrot);
}

.new-user-id {
  font-size: 18px;
}

span.small {
  color: var(--secondary-color);
}

.user-info {
  * {
    h5 {
      display: flex;
      align-items: center;
      flex-flow: wrap;
      /* white-space: initial; */
      word-break: break-word;
      white-space: pre-wrap;
    }

    span {
      display: inline-flex;
      align-items: center;
    }

    b,
    label {
      font-weight: 600;
    }
  }
}
</style>

<style lang="postcss">

#user-admin {
  width: 100%;

  /* Glass morphism effect uses global glass-card styles from tailwind.css */

  h5 {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
  }

  .nav-links {
    @media only screen and (max-width: 768px) {
      margin-top: 0.5rem;
      font-size: 1rem;
    }
  }

  .PLink--success {
    /* color: var(--nord-green); */
    color: #32895f;
  }

  @media (max-width: 768px) {
    padding: 5px;
  }

  input {
    font-size: 1.1rem;
  }

  .inline-action {
    font-size: 12px;

    /* margin: 0 5px 5px 0px; */
    @media (max-width: 768px) {
      /* margin: 0 5px 5px 0px; */
      padding: 10px 18px !important;
    }
  }

  .PLink--info {
    color: var(--primary-color);
  }
}
</style>
